import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-10 pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-7xl mx-auto 2xl:max-w-screen-2xl"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white" }, "Thank you for signing up!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal mt-4 text-white" }, " We’re reviewing your profile. In the meantime please ensure that all the loan criterias look right ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "max-w-7xl mx-auto 2xl:max-w-screen-2xl"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white" }, "Personal settings", -1)
const _hoisted_8 = { class: "bg-white px-4 md:px-6 py-6 rounded-lg shadow-sm flex items-center justify-between mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Verify that the loan criteria in your profile is complete to maximize the quality of your deal matches. ", -1)
const _hoisted_10 = { class: "flex items-center justify-start" }
const _hoisted_11 = { class: "bg-blue-100 w-20 h-20 rounded-lg items-center justify-center flex-shrink-0 ml-4 hidden md:flex" }
const _hoisted_12 = { class: "grid grid-cols-1 lg:grid-cols-9 gap-4" }
const _hoisted_13 = { class: "col-span-5" }
const _hoisted_14 = { class: "col-span-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AnnotationIcon = _resolveComponent("AnnotationIcon")!
  const _component_contacts = _resolveComponent("contacts")!
  const _component_terms = _resolveComponent("terms")!
  const _component_LoanSettings = _resolveComponent("LoanSettings")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      (!_ctx.termsAccepted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "mr-2 border border-sky px-3 py-2 text-sky rounded-md text-sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('#credit-box')))
                  }, " Edit credit box "),
                  _createVNode(_component_router_link, {
                    to: "/deals",
                    class: "inline-block bg-sky text-white px-3 py-2 rounded-md text-sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Go to the deals ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_AnnotationIcon, { class: "text-sky w-6 h-6" })
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_contacts)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_terms)
      ])
    ]),
    _createVNode(_component_LoanSettings)
  ], 64))
}